module.exports = __webpack_public_path__ + "static/media/info.daddeb6b.svg";